import React,{ useState, useRef, useEffect, Fragment } from 'react';
import _ from "lodash";
import cx from "classnames";
import { Button } from 'react-bootstrap';
import { Sortable } from "@shopify/draggable";
import styles from '../../fields.module.scss';

export const ListFieldOption = React.forwardRef(({ handleChange, handleDelete, selection, deletingId, disabled}, ref) => {

  const fieldId = _.get(selection, 'id', null);
  const options = _.get(selection, 'options', []);
  const prevOptionsLengthRef = useRef(options.length);
  const isPaperfliteSource = selection && selection.source === "PAPERFLITE";

  
  useEffect(() => {
    if (options.length > prevOptionsLengthRef.current && ref.current) {
        ref.current.scrollTo({ top: ref.current.scrollHeight, behavior: 'smooth' });
    }
    prevOptionsLengthRef.current = options.length;
  }, [options]);

  useEffect(()=>{
    if(fieldId && ref.current){
      ref.current.scrollTo({ top: 0 });
    }
  },[fieldId])

  return (
    <Fragment>
      {selection && selection.options && selection.options.length == 0 && <EmptyMessage />}

      {options.map(option => {
          return(
            <Option 
              option={option}
              selection={selection}
              onDelete={isPaperfliteSource ? undefined : (option) => handleDelete(option)}
              handleChange={isPaperfliteSource ? "" : (e, option) => handleChange(e, option)}
              sortable={Sortable} 
              deletingId={deletingId}
              disabled={disabled}
              isPaperfliteSource={isPaperfliteSource}
            />
          )
        })
      }
    </Fragment>
  )
})

const Option = ({ option, onDelete, handleChange, deletingId, disabled, isPaperfliteSource }) => {

  const handleInputChange = (e) => {
    if (handleChange) {
      handleChange(e, option);
    }
  };

  const handleDeleteClick = () => {
    if (onDelete) {
      onDelete(option);
    }
  };

  return (
    <div className={cx(styles.option, 'cs-draggable-item', {[styles.deleteAnimation]: deletingId === option.id, [styles.disableDrag] :disabled})} key={option.id} >
      <div className={styles.value}>
        <span className={cx(styles.dragHandle, 'cs-drag')}>
          <i className={cx('cleverstory-drag', styles.dragIcon)} />
        </span>
        <input className={styles.name} key={option.id} value={option.value} disabled={!handleChange}
         onChange={(e) => handleInputChange(e, option)} />
         {!isPaperfliteSource && 
          <Button variant="secondary" className={styles.btnDelete} onClick={handleDeleteClick}>
            <i className={'cleverstory-trash'} />
          </Button>
        }
      </div>
    </div>
  )
}

const EmptyMessage = () => {
  return (
    <div className={styles.emptyMessage}>Add Options to the List</div>
  )
}